<template>
    <a :href="item.link" class="item">
        
        <div class="wrapper-desc">
            <div class="cell image" :class="{sold: item.sold}">
                <img :src="item.thumb" :alt="item.title">
                <div class="price-smart">{{item.price.toLocaleString('fr-FR')}} €</div>
            </div>
            <div class="cell info">
                <div class="row full title">
                    <h3>{{item.title}}</h3>
                    <div class="price">{{item.price.toLocaleString('fr-FR')}} €</div>
                </div>
                <div class="row full">
                    <p>{{item.desc}}</p>
                </div>
                <div class="row">
                    <div class="picto city">{{item.city}}</div>
                    <div class="picto room">{{item.room}} Pièces</div>
                </div>
                <div class="row">
                    <div class="picto surface">{{item.surface}} m2</div>
                    <div class="picto bedroom">{{item.bedroom}} Chambres</div>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "PropertyElement",
    props: {
        item: Object
    },
}
</script>

<style>
.item {
    display: block;
    margin-bottom: 20px;
    color: rgb(29, 29, 29);
    text-decoration: none;
}
 p {
     padding: 0;
     margin:0;
 }
 .city {
    font-size: 12px;
 }
 .price {
    font-weight: 700;
 }
 .wrapper-desc {
     display: flex;
     flex-direction: row;
 }
 .wrapper-desc .cell.image {
     flex: 0 0 25%;
     max-width: 25%;
 }
 .wrapper-desc img{
     width: 100%;
 }
 .wrapper-desc .cell.info {
     flex: 0 0 75%;
     max-width: 75%;
     margin: 0 10px;
 }
</style>